
import { IStressBarometer } from "../interfaces/IStressBarometer";
import { IUser } from "../interfaces/IUser";

export default class StressBarometerService {

  // Admin
  public static getStressBarometersForAdmin(adminId: string): Promise<IStressBarometer[]> {
    return new Promise((resolve) => {
      fetch(`https://mindjuice.herokuapp.com/parse/classes/StressBarometer/?where={\"adminId\":\"${adminId}\"}`, {
        headers: {
          'X-Parse-Application-Id': 'mindjuice',
        }
      }).then((response) => {
        if (!response.ok) {
          resolve(undefined);
        } else {
          return response.json();
        }
      }).then(response => {
        if (response.results.length > 0) {
          resolve(response.results);
        }
        resolve(undefined);
      }).catch((error) => {
        console.log(error);
        resolve(undefined);
      });
    });
  }


  // User

  public static getStressBarometersForUser(user: IUser): Promise<IStressBarometer[]> {
    return new Promise((resolve) => {
      fetch(`https://mindjuice.herokuapp.com/parse/classes/StressBarometer/?where={\"userId\":\"${user.id}\"}`, {
        headers: {
          'X-Parse-Application-Id': 'mindjuice',
        }
      }).then((response) => {
        if (!response.ok) {
          resolve(undefined);
        } else {
          return response.json();
        }
      }).then(response => {
        if (response.results.length > 0) {
          resolve(response.results);
        }
        resolve(undefined);
      }).catch((error) => {
        console.log(error);
        resolve(undefined);
      });
    });
  }

  public static getStressBarometersWithId(user: IUser, id: string): Promise<IStressBarometer> {
    return new Promise((resolve) => {
      fetch(`https://mindjuice.herokuapp.com/parse/classes/StressBarometer/${id}`, {
        headers: {
          'X-Parse-Application-Id': 'mindjuice',
        }
      }).then((response) => {
        if (!response.ok) {
          resolve(undefined);
        } else {
          return response.json();
        }
      }).then(response => {
        if (response && response.userId === user.id) {
          resolve(response);
        }
        resolve(undefined);
      }).catch((error) => {
        console.log(error);
        resolve(undefined);
      });
    });
  }

  public static createStressBarometer(stressBarometer: IStressBarometer): Promise<string> {
    return new Promise((resolve) => {
      fetch(`https://mindjuice.herokuapp.com/parse/classes/StressBarometer/`, {
        method: "POST",
        headers: {
          'X-Parse-Application-Id': 'mindjuice'
        },
        body: JSON.stringify(
          stressBarometer
        )
      }).then((response) => {
        if (!response.ok) {
          resolve(undefined);
        } else {
          return response.json();
        }
      }).then(response => {
        if (response && response.objectId) {
          resolve(response.objectId);
        }
        resolve(undefined);
      }).catch((error) => {
        console.log(error);
        resolve(undefined);
      });
    });
  }

  public static updateStressBarometer(stressBarometer: IStressBarometer): Promise<void> {
    return new Promise((resolve) => {
      fetch(`https://mindjuice.herokuapp.com/parse/classes/StressBarometer/${stressBarometer.objectId}`, {
        method: "PUT",
        headers: {
          'X-Parse-Application-Id': 'mindjuice',
        },
        body: JSON.stringify({
          title: stressBarometer.title,
          areas: stressBarometer.areas,
          allowUserToEditAreas: stressBarometer.allowUserToEditAreas
        })
      }).then((response) => {
        if (!response.ok) {
          resolve();
        } else {
          resolve();
        }
      }).catch((error) => {
        console.log(error);
        resolve();
      });
    });
  }
}